import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseInput } from './BaseInput.js';
import 'classnames';
import '@hh.ru/magritte-common-mouse';
import '@hh.ru/magritte-common-text-selection';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-common-use-multiple-refs';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-form-helper';
import '@hh.ru/magritte-ui-icon/icon';
import './useFocus.js';
import './useInputAriaProps.js';
import '@hh.ru/magritte-ui-typography';

// Здесь создаем новый компонент, а не переиспользуем BaseInput as <...>, чтобы обеспечить уникальность displayName
const InputComponent = (props, ref) => jsx(BaseInput, { ref: ref, ...props });
const Input = forwardRef(InputComponent);
Input.displayName = 'Input';

export { Input };
//# sourceMappingURL=Input.js.map
